import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

@font-face {
  font-family: 'Wotfard';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('../../static/fonts/wotfard-regular-webfont.woff2') format('woff2');
}
@font-face {
  font-family: 'Wotfard';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('../../static/fonts/wotfard-medium-webfont.woff2') format('woff2');
}
@font-face {
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('../../static/fonts/Gilroy-Bold.woff2') format('woff2');
}

:root {
  --fontFamily-gilroy: Gilroy, system-ui, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, Verdana, 'Helvetica Neue', Arial, 'Noto Sans',
    sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  --fontFamily-wotfard: Wotfard, system-ui, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  --font-body: var(--fontFamily-wotfard);
  --font-heading: var(--fontFamily-gilroy);

  --fontWeight-normal: 400;
  --fontWeight-medium: 500;
  --fontWeight-semibold: 600;
  --fontWeight-bold: 700;
  --fontWeight-extrabold: 800;
  --fontWeight-black: 900;
  --fontSize-root: 16px;

  --lineHeight-none: 1;
  --lineHeight-tight: 1.3;
  --lineHeight-normal: 1.5;
  --lineHeight-relaxed: 1.625;

  /* 1.200 Minor Third Type Scale */
  --fontSize-0: 0.833rem;
  --fontSize-1: 1rem;
  --fontSize-2: 1.2rem;
  --fontSize-3: 1.44rem;
  --fontSize-4: 1.728rem;
  --fontSize-5: 2.074rem;
  --fontSize-6: 2.488rem;
  --fontSize-7: 2.986rem;

  /* Colors */
  --color-primary: var(--indigo-dark);
  --color-secondary: var(--emerald);
  --color-blue: #243659;
  --color-heading: #364962;
  --color-accent-pink: #fd2d55;
  --color-accent-green: #3cbf8a;
  --color-accent-orange: #f05453;
  --color-text: #2e353f;

  // --color-text: #494d58;
  --color-grey: #6f6f6f;
  --color-light: #9b9b9b;
  --color-accent: #d1dce5;
  --color-white: #fff;
  --color-black: #000;
  --color-cool-white: #f7f7fc;

  /* Easing */
  --easing-quad: cubic-bezier(0.785, 0.135, 0.15, 0.86);
  --ease-in-out-quad:   cubic-bezier(.455, .03, .515, .955);

  /* Shadow */
  --card-shadow: 0 8px 16px rgb(0 52 102 / 10%), 0 2px 6px rgb(0 52 102 / 6%);
}

/* Margin Padding Reset */

*,
:after,
:before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* border-radius: 3px; */
}

/* HTML elements */
html:not(.tableskit *) {
  line-height: var(--lineHeight-normal);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
  font-size: var(--fontSize-root);
}

body:not(.tableskit *) {
  font-family: var(--font-body);
  font-size: var(--fontSize-1);
  color: var(--color-text);
  background-color: #edf1f6;
  font-weight: 500;
}

// ::selection {
//   background-color: #3d5afe26;
// }
 ::-webkit-scrollbar {
   width: 12px;
   background-color: transparent;

 }
 ::-webkit-scrollbar-track {
   border-radius: 3px;
   background-color: transparent;
 }
 ::-webkit-scrollbar-thumb {
   border-radius: 12px;
   background-color: var(--color-primary);
   border: 2px solid #f4f7ff;
 }

hr {
  background: var(--color-accent);
  height: 1px;
  border: 0;
}

/* Heading */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--font-heading);
  line-height: var(--lineHeight-tight);
  color: var(--color-heading);
  -webkit-font-smoothing: auto;
}

h2,
h3,
h4,
h5,
h6 {
  font-weight: var(--fontWeight-bold);
  color: var(--color-heading);
}

h1 {
  font-size: var(--fontSize-6);
}

h2 {
  font-size: var(--fontSize-5);
}

h3 {
  font-size: var(--fontSize-4);
}

h4 {
  font-size: var(--fontSize-3);
}

h5 {
  font-size: var(--fontSize-2);
}

h6 {
  font-size: var(--fontSize-1);
}

h1 > a {
  color: inherit;
  text-decoration: none;
}

h2 > a,
h3 > a,
h4 > a,
h5 > a,
h6 > a {
  text-decoration: none;
  color: inherit;
}

/* Prose */
p {
  font-family: var(--font-body);
  line-height: var(--lineHeight-normal);
  --baseline-multiplier: 0.179;
  --x-height-multiplier: 0.35;
}
button{
  font-family: var(--font-body);
  font-size: var(--fontSize-1);
  color: var(--color-text);
  font-weight: 500;
}
ul,
ol {
  list-style: none;
  list-style-position: outside;
  list-style-image: none;
}

button {
  font-size: var(--fontSize-root);
}

blockquote {
  border-left: 0.4rem solid var(--color-primary);
  font-style: italic;
}

blockquote > ul,
blockquote > ol {
  list-style-position: inside;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0.25rem;
}

table thead tr th {
  border-bottom: 1px solid var(--color-accent);
}

/* Link */
a {
  color: var(--color-primary);
  text-decoration: none;
}

a:hover,
a:focus {
  text-decoration: none;
}

/* Use BoxShadow as Outline */
a[href],
area[href],
input:not([disabled]),
select:not([disabled]),
textarea:not([disabled]),
button:not([disabled]),
iframe,
object,
embed,
*[tabindex],
*[contenteditable] {
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: none;
    // box-shadow: 0 0 0px 2px rgba($color: #ffffff, $alpha: 0.8),
    //   0 0 1px 4px rgba($color: #af3a3a, $alpha: 0.8);
    box-shadow: 0 0 0px 2px rgba(255, 255, 255, 0.5),
      0 0 1px 3px var(--indigo-lighter);
  }
}

/* Media queries */
@media (max-width: 42rem) {
  ul,
  ol {
    list-style-position: inside;
  }
}

/* Additional Global CSS */
body.tippy-active  {
  user-select: none;
  pointer-events: none;
}

[data-tippy-root] {
  pointer-events: all !important;
  color: red !important;
}
`;
